import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import {registerRouterStore} from "./router.ts";
import {registerAgeConfirmStore} from "./ageConfirm.ts";
import {registerContestStore} from "./contest.ts";
import {registerPrizeStore} from "./prize.ts";
import './sentry.ts'

window.Alpine = Alpine;

Alpine.plugin(persist);

registerRouterStore(Alpine);
registerAgeConfirmStore(Alpine);
registerContestStore(Alpine);
registerPrizeStore(Alpine);

Alpine.start();
Alpine.store('router').init();
